import React, { useState } from "react";
import "./Navigation.css";
import { NavLink } from "react-router-dom";

function Navigation() {
  const [activemenu, setActiveMenu] = useState("nav_menu");
  const [toggleicon, setToggleIcon] = useState("toggle");

  const ToggleMenu = () => {
    if (activemenu === "nav_menu") {
      setActiveMenu("nav_menu nav_phone");
      setToggleIcon("toggle toggle1");
    } else {
      setActiveMenu("nav_menu");
      setToggleIcon("toggle");
    }
  };
  return (
    <div>
      <div className="container-fluid nav">
        <div className="logo">
              <h1>
                <NavLink to="/">
                  <span>H</span>as<span>A</span>n
                </NavLink>
              </h1>
        </div>
        <div>
          <ul className={activemenu}>
            <li>
              <NavLink onClick={ToggleMenu} to="/about">
                About
              </NavLink>
            </li>
            <li>
              <NavLink onClick={ToggleMenu} to="/portfolio">
                Portfolio
              </NavLink>
            </li>
            <li>
              <NavLink onClick={ToggleMenu} to="/service">
                Service
              </NavLink>
            </li>
            <li>
              <NavLink onClick={ToggleMenu} to="/contact_me">
                Contact Me
              </NavLink>
            </li>

          </ul>
             
        </div>
        <div onClick={ToggleMenu} className={toggleicon}>
          <div className="line-1"></div>
          <div className="line-2"></div>
          <div className="line-3"></div>
        </div>
      </div>
    </div>
  );
}

export default Navigation;